import { inject, Injectable } from '@angular/core';
import { BaseRequestService, CommunityUser, ResponseList, ShortVideoLiked } from '@outlaw/core';
import { Observable } from 'rxjs';
import { CommunityConfigService } from '../util/community-config.service';
import { ArgoVideoAccess } from '../../interfaces/access';
import { VideoAccess } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class VideoService extends BaseRequestService {
  #communityConfigService = inject(CommunityConfigService);

  #argoApiUrl = this.#communityConfigService.getConfig().externalApi.argo;
  #externalVideoUrl = this.#communityConfigService.internalApi.externalVideoUrl;
  #videoUrl = this.#communityConfigService.internalApi.videoUrl;

  getVideos(): Observable<ResponseList<ShortVideoLiked>> {
    return this.http.get<ResponseList<ShortVideoLiked>>(this.prepareUrl([this.#videoUrl, 'community_recommendations']));
  }

  hasVideoAccess(videoId: number): Observable<VideoAccess> {
    return this.http.get<VideoAccess>(this.prepareUrl([this.#externalVideoUrl, videoId, 'access']));
  }

  hasArgoVideoAccess(videoId: number): Observable<ArgoVideoAccess> {
    return this.http.get<ArgoVideoAccess>(`${this.#argoApiUrl}/client/v3/access/${videoId}/`);
  }

  getVideoFollowers(videoId: number, page?: number): Observable<ResponseList<CommunityUser>> {
    return this.pagedGet<CommunityUser>([this.#videoUrl, videoId, 'community_recommendations'], page);
  }
}
